import React, { useState, useEffect, useRef } from "react";
import style from "./style.module.css";

function View({ data }) {
    const calculateTimeLeft = () => {
        const now = Math.floor(Date.now() / 1000);
        const difference = data - now;

        let timeLeft = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
        };

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (60 * 60 * 24)),
                hours: Math.floor((difference / (60 * 60)) % 24),
                minutes: Math.floor((difference / 60) % 60),
                seconds: Math.floor(difference % 60),
            };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);
    const prevTimeRef = useRef(timeLeft);
    const [animKey, setAnimKey] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    useEffect(() => {
        const timer = setInterval(() => {
            const newTime = calculateTimeLeft();

            // Cascading animation logic
            if (newTime.days !== prevTimeRef.current.days) {
                setAnimKey((k) => ({
                    days: k.days + 1,
                    hours: k.hours + 1,
                    minutes: k.minutes + 1,
                    seconds: k.seconds + 1,
                }));
            } else if (newTime.hours !== prevTimeRef.current.hours) {
                setAnimKey((k) => ({
                    ...k,
                    hours: k.hours + 1,
                    minutes: k.minutes + 1,
                    seconds: k.seconds + 1,
                }));
            } else if (newTime.minutes !== prevTimeRef.current.minutes) {
                setAnimKey((k) => ({
                    ...k,
                    minutes: k.minutes + 1,
                    seconds: k.seconds + 1,
                }));
            } else if (newTime.seconds !== prevTimeRef.current.seconds) {
                setAnimKey((k) => ({
                    ...k,
                    seconds: k.seconds + 1,
                }));
            }

            setTimeLeft(newTime);
            prevTimeRef.current = newTime;
        }, 1000);

        return () => clearInterval(timer);
    }, [data]);

    const renderTimeBlock = (value, label, key) => (
        <div className={style.time}>
            {/* key changes => React re-mounts => CSS animation restarts */}
            <h3 key={key} className={style.animate}>
                {String(value).padStart(2, "0")}
            </h3>
            <p>{label}</p>
        </div>
    );

    return (
        <div className={style.parentView}>
            {timeLeft.days > 0 &&
                renderTimeBlock(timeLeft.days, "Days", animKey.days)}
            {renderTimeBlock(timeLeft.hours, "Hours", animKey.hours)}
            {renderTimeBlock(timeLeft.minutes, "Min", animKey.minutes)}
            {renderTimeBlock(timeLeft.seconds, "Sec", animKey.seconds)}
        </div>
    );
}

export default View;


